import { captureException } from '@sentry/react';

export const logError = (error) => {
  captureException(error);
  console.error(error);
};
